import { toast } from "react-toastify";

const appNotificaton = ({ type, message }) => {
  toast(message, {
    type,
  });
};

export default appNotificaton;
